import React from 'react';
import { Row } from 'react-bootstrap';
import { Field } from 'formik';
import { CustomSelectComponent, FieldInput, FormCol, FormFilterCard } from 'motion-components';
import { useTranslation } from 'react-i18next';
import { ENTITY_TYPE_OPTIONS } from 'shared-pages/common/entity-params-types';

/* ----------------------- Build Where ------------------------------ */
export function buildWhereFromFilterValues(values: any): string {
  let where: any = {};
  if (values) {
    if (values.searchText) {
      const searchText = '%' + values.searchText + '%';
      const likeObj = { $like: searchText };
      where = {
        ...where,
        $or: [{ paramName: likeObj }, { '$appParam.description$': likeObj }],
      };
    }
    if (values.entityType) {
      where = { ...where, entityType: values.entityType };
    }
    if (values.paramGroup) {
      where = { ...where, paramGroup: values.paramGroup };
    }
    if (values.applies !== undefined && values.applies !== null && values.applies !== '') {
      const appliesValue = values.applies === true || values.applies === 1 || values.applies === '1' ? 1 : 0;
      where = { ...where, applies: appliesValue };
    }
  }
  return JSON.stringify(where);
}

/* ----------------------- Filters ---------------------------------- */
export const Filters = ({ onChange, initialValues, groupOptions }: any) => {
  const { t } = useTranslation();

  function handleFiltersSubmit(values: any, { setSubmitting }: any) {
    setTimeout(() => {
      setSubmitting(false);
      onChange(values);
    }, 200);
  }

  const filters = {
    searchText: initialValues?.searchText ?? '',
    entityType: initialValues?.entityType ?? '',
    paramGroup: initialValues?.paramGroup ?? '',
    applies: initialValues?.applies ?? 1,
  };

  return (
    <FormFilterCard
      title={t('Κριτήρια Αναζήτησης')}
      onSubmit={handleFiltersSubmit}
      initialValues={filters}
    >
      <Row>
        <FieldInput
          as={FormCol}
          name="searchText"
          label={t('Αναζήτηση (Παράμετρος)')}
          type="search"
        />
        <Field
          as={FormCol}
          name="entityType"
          title={t('Τύπος Παραλήπτη')}
          component={CustomSelectComponent}
          options={ENTITY_TYPE_OPTIONS}
        />
        <Field
          as={FormCol}
          name="paramGroup"
          title={t('Ομάδα Παραμέτρων')}
          component={CustomSelectComponent}
          options={groupOptions ?? []}
        />
        <Field
          as={FormCol}
          name="applies"
          title={t('Ισχύει')}
          component={CustomSelectComponent}
          options={[
            { value: 1, label: t('Ναι') },
            { value: 0, label: t('Όχι') },
          ]}
        />
      </Row>
    </FormFilterCard>
  );
};
